import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { Xmark } from "iconoir-react"

const AllSet = ({
  open,
  handleContinue,
  handleClose,
}: {
  open: boolean
  handleContinue: () => void
  handleClose?: () => void
}) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")
  const Content = (
    <div>
      <div className="flex items-center justify-between p-2.5">
        <Typography variant="title3">You’re all set!</Typography>
        <IconButton autoFocus={false} onClick={handleClose} color="black">
          <Xmark />
        </IconButton>
      </div>
      <div className="px-2.5">
        <Typography variant="smallBody" className="text-onSurface-600">
          You now know how everything works. Before you click start, please
          ensure:
        </Typography>
        <ul className="mb-1 list-disc pl-2 pt-1 text-smallBody text-onSurface-600">
          <li>
            <span className="text-strongSmallBody">
              Your environment is well-lit
            </span>{" "}
            so your face is clearly visible.
          </li>
          <li>
            <span className="text-strongSmallBody">Your camera is active</span>{" "}
            and positioned correctly.
          </li>
          <li>
            <span className="text-strongSmallBody">
              You have a stable internet connection
            </span>{" "}
            to avoid interruptions.
          </li>
        </ul>

        <Typography variant="smallBody">All the best!</Typography>
      </div>
      <div className="flex items-center justify-end gap-1.5 px-2.5 py-3">
        <Button
          onClick={handleClose}
          className="bg-[#F4F6F8] text-onSurface-700"
          color="null"
          autoFocus={false}
        >
          Later
        </Button>
        <Button autoFocus onClick={handleContinue} color="black">
          Start Assessment
        </Button>
      </div>
    </div>
  )
  if (isSmDown) {
    return (
      <Sheet open={open}>
        <SheetContent height={78} className="!p-0">
          <SheetBody className="!p-0">{Content}</SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>{Content}</DialogContent>
    </Dialog>
  )
}

export default AllSet
